import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { Menu, MenuItem } from "@mui/material";
import { type FC } from "react";
import FileUploadIcon from '@mui/icons-material/FileUpload';

import "./MoreActions.scss";

interface MoreActionsProps {
  anchorEl: EventTarget | null;
  handleChange?: () => void;
  onClose: () => void;
  handleExport?: () => void;
  deleteLabel?: string;
}

export const MoreActions: FC<MoreActionsProps> = (props) => {
  const {
    anchorEl = null,
    handleChange,
    onClose,
    handleExport,
    deleteLabel = "מחיקה",
  } = props;

  return (
    <Menu
      classes={{
        paper: "more-actions-container",
        list: "more-actions-list-container",
      }}
      slotProps={{ paper: { sx: { borderRadius: "20px" } } }}
      onClose={onClose}
      open={!!anchorEl}
      anchorEl={anchorEl as HTMLElement}
      anchorOrigin={{
        horizontal: "center",
        vertical: "top",
      }}

      transformOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
    >
      {handleChange && <MenuItem
        onClick={handleChange}
        style={{
          color: "#00b4d8",
          display: "flex",
          flexDirection: "column",
          fontWeight: "500",
        }}
      >
        <DeleteRoundedIcon />
        {deleteLabel}
      </MenuItem>}
      {handleExport && <MenuItem
        onClick={handleExport}
        style={{
          color: "#00b4d8",
          display: "flex",
          flexDirection: "column",
          fontWeight: "500",
        }}
      >
        < FileUploadIcon />
        ייצוא לאקסל
      </MenuItem>}
    </Menu>
  );
};
